export enum OcorrenciaTypes {
  'LOAD_REQUEST' = '@ocorrencia/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@ocorrencia/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@ocorrencia/LOAD_FAILURE',

  'LOAD_REQUEST_UPDATE' = '@ocorrencia/@LOAD_REQUEST_UPDATE',
  'LOAD_SUCCESS_UPDATE' = '@ocorrencia/LOAD_SUCCESS_UPDATE',
  'LOAD_FAILURE_UPDATE' = '@ocorrencia/LOAD_FAILURE_UPDATE',
}

export interface Usuario {
  codUsu: number;
  nome: string;
  avatar: string;
}

export interface NotasOcorrencia {
  manual: string;
  nunota: number;
  numNota: number;
  valor: number;
  peso: number;
  dtEmissao: string;
  remetente: string;
  origem: string;
  destinatario: string;
  destino: string;
}

export interface MensagensOcorrencia {
  texto: string;
  codUsu: number;
  dhInclusao: string;
  anexos: number;
  lido: boolean;
  seq: number;
}

export interface Ocorrencia {
  dhAbertura: string;
  centrodistribuicao: string;
  parceiro: string;
  nomeStatus: string;
  tipoSolicitacao: string;
  dhConclusao: string;
  protocolo: number;
  assunto: string;
  atendente: string;
  urgencia: string;
  status: string;
  codAtendente: number;
  notas: NotasOcorrencia[];
  usuarios: Usuario[];
  mensagens: MensagensOcorrencia[];
}

export interface OcorrenciaState {
  readonly data: Ocorrencia[];
  readonly error: boolean;
  readonly loading: boolean;
}
